import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const STORAGE_KEY = 'aruba-animal-radar-beta-notice-2026-07-19'

function wasDismissed() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'dismissed'
  } catch {
    return false
  }
}

export function BetaNotice() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(() => !wasDismissed())

  if (!open) return null

  function dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'dismissed')
    } catch {
      // The notice still closes when storage is unavailable.
    }
    setOpen(false)
  }

  return (
    <div className="beta-notice-backdrop">
      <section
        className="beta-notice"
        role="dialog"
        aria-modal="true"
        aria-labelledby="beta-notice-title"
        aria-describedby="beta-notice-description"
      >
        <div className="beta-notice-kicker">{t('beta.kicker')}</div>
        <h2 id="beta-notice-title">{t('beta.title')}</h2>
        <p id="beta-notice-description">{t('beta.demoData')}</p>
        <a className="beta-contact" href="mailto:info@arubaanimalradar.com">
          info@arubaanimalradar.com
        </a>
        <div className="beta-notice-footer">
          <time dateTime="2026-07-19">{t('beta.noticeDate')}</time>
          <button type="button" className="btn btn-primary" onClick={dismiss} autoFocus>
            {t('beta.acknowledge')}
          </button>
        </div>
      </section>
    </div>
  )
}
